import { useState } from 'react';
import { useAsync } from 'react-async';
import { checkApi, checkDb } from '../../api/services/healthcheckService';

const Healthcheck = () => {
  const [db, setDb] = useState('');
  const [dbErrors, setDbErrors] = useState('');

  const { error, isPending } = useAsync({
    promiseFn: checkApi,
  });

  useAsync({
    promiseFn: checkDb,
    onResolve: (r) => {
      setDb(String(r.data));
    },
    onReject: (error) => {
      setDbErrors(String(error));
    },
  });

  return (
    <div className='w-full bg-gray-100'>
      <div className='overflow-hidden bg-white shadow sm:rounded-lg'>
        <div className='px-4 py-5 sm:px-6'>
          <h3 className='text-lg font-medium leading-6 text-gray-900'>
            Healthcheck page
          </h3>
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='px-4 py-5 bg-white sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>
                API Connectivity:
              </dt>
              {!isPending && (
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {error === undefined ? 'Success' : 'Failure. ' + error}
                </dd>
              )}
            </div>
            <div className='py-5 bg-gray-50px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>
                Database Connectivity:
              </dt>
              {!isPending && (
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {db === 'true' ? 'Success' : 'Failure. ' + dbErrors}
                </dd>
              )}
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};
export default Healthcheck;
